<script lang="ts">
  import type { SearchResultItemProps } from "../SearchControllers";
  import type { PlaylistItem } from "module/audioIndex";

  let {
    density,
    resultItem,
    selected,
    selectedAction,
    callAction,
  }: SearchResultItemProps = $props();

  let item = $derived(resultItem.item) as PlaylistItem;
  let { formattedMatch, actions, defaultAction } = $derived(resultItem);
</script>

<li class:search-selected={selected} class="no-icon-result">
  <a
    onclick={(e) =>
      callAction({ actionId: undefined, item, shiftKey: e.shiftKey })}
    draggable="true"
    ondragstart={(event) =>
      event.dataTransfer?.setData(
        "text/plain",
        JSON.stringify({
          type: "Playlist",
          uuid: item.instance.uuid,
        })
      )}
  >
    <i class="fa-solid fa-music entity-icon"></i>
    {#if density === "spacious"}
      <div class="two-line-item">
        <span class="title">
          {@html formattedMatch || item.instance.name}
        </span>
        <span class="sub"
          >{#if item.instance.playing}
            <i class="fa-solid fa-play"></i>
            {item.track}
          {/if}</span
        >
      </div>
    {:else}
      <span class="title">
        {@html formattedMatch || item.instance.name}
      </span>
      <span class="sub"
        >{#if item.instance.playing}
          <i class="fa-solid fa-play"></i>
          {item.track}
        {/if}</span
      >
    {/if}
    <span class="action-icons">
      {#each actions || [] as action}
        <i
          class="{action.icon} action-icon"
          class:selected={selected &&
            (actions?.some((a) => a.id === selectedAction)
              ? action.id === selectedAction
              : action.id == defaultAction)}
          data-tooltip={action.title}
          data-tooltip-direction="UP"
          data-action-id={action.id}
          onclick={(e) =>
            callAction({ actionId: action.id, item, shiftKey: e.shiftKey })}
        ></i>
      {/each}
    </span>
  </a>
</li>

<style>
  a {
    padding: 4px;
  }
</style>
